import { render } from "./pagination.vue?vue&type=template&id=f2e26a4a&scoped=true"
import script from "./pagination.vue?vue&type=script&lang=js"
export * from "./pagination.vue?vue&type=script&lang=js"

import "./pagination.vue?vue&type=style&index=0&id=f2e26a4a&scoped=true&lang=css"

import exportComponent from "/Users/tizetimoyosore/Developer/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e26a4a"]])

export default __exports__